import { render, staticRenderFns } from "./position-list-filter.vue?vue&type=template&id=0645df7e&"
import script from "./position-list-filter.vue?vue&type=script&lang=js&"
export * from "./position-list-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports